import {
  BanknotesIcon,
  CalendarDaysIcon,
  CalendarIcon,
  ChartBarIcon,
  ClockIcon,
  Cog6ToothIcon,
  CogIcon,
  CreditCardIcon,
  DocumentTextIcon,
  EyeIcon,
  EyeSlashIcon,
  FolderIcon,
  HomeIcon,
  IdentificationIcon,
  InboxIcon,
  NewspaperIcon,
  NoSymbolIcon,
  PencilIcon,
  PencilSquareIcon,
  PlusIcon,
  PresentationChartBarIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
  TagIcon,
  TrashIcon,
  LockOpenIcon,
  LockClosedIcon,
  UserIcon,
  UsersIcon,
  XCircleIcon,
  Squares2X2Icon,
  MegaphoneIcon,
  WindowIcon,
  PhoneIcon,
  AdjustmentsVerticalIcon,
  AdjustmentsHorizontalIcon,
  FunnelIcon,
} from '@heroicons/react/24/outline';
import { ReactElement } from 'react';
import { Size, cn } from '@jobcost-monorepo/utils';

type HeroIconsName =
  | 'banknotesIcon'
  | 'calendarDaysIcon'
  | 'calendarIcon'
  | 'chartBarIcon'
  | 'clockIcon'
  | 'cogIcon'
  | 'creditCardIcon'
  | 'documentTextIcon'
  | 'eyeIcon'
  | 'eyeSlashIcon'
  | 'filterHorizontal'
  | 'filterVertical'
  | 'folderIcon'
  | 'funnelIcon'
  | 'homeIcon'
  | 'identificationIcon'
  | 'inboxIcon'
  | 'megaphoneIcon'
  | 'newspaperIcon'
  | 'noSymbolIcon'
  | 'lockIcon'
  | 'pencilIcon'
  | 'pencilSquareIcon'
  | 'phoneIcon'
  | 'plusIcon'
  | 'presentationChartBar'
  | 'settingsIcon'
  | 'shieldCheckIcon'
  | 'shieldExclamationIcon'
  | 'squares2X2Icon'
  | 'tagIcon'
  | 'trashIcon'
  | 'unlockIcon'
  | 'userIcon'
  | 'usersIcon'
  | 'windowIcon'
  | 'xCircleIcon';

interface Props {
  name: HeroIconsName;
  current?: boolean;
  size?: Size;
  iconColor?: string;
  activeColor?: string;
  hoverColor?: string;
}

const IconSvg = ({
  name,
  current,
  size = '6',
  iconColor = 'indigo',
  activeColor = 'white',
  hoverColor = 'white',
}: Props): ReactElement => {
  const iconStyle = cn(
    current
      ? `text-${activeColor}-500`
      : `text-${iconColor}-300 group-hover:text-${hoverColor}-500`,
    `h-${size} w-${size} `,
  );

  const Icons = {
    filterVertical: (
      <AdjustmentsVerticalIcon className={iconStyle} aria-hidden="true" />
    ),
    filterHorizontal: (
      <AdjustmentsHorizontalIcon className={iconStyle} aria-hidden="true" />
    ),
    homeIcon: <HomeIcon className={iconStyle} aria-hidden="true" />,
    usersIcon: <UsersIcon className={iconStyle} aria-hidden="true" />,
    userIcon: <UserIcon className={iconStyle} aria-hidden="true" />,
    folderIcon: <FolderIcon className={iconStyle} aria-hidden="true" />,
    calendarIcon: <CalendarIcon className={iconStyle} aria-hidden="true" />,
    inboxIcon: <InboxIcon className={iconStyle} aria-hidden="true" />,
    chartBarIcon: <ChartBarIcon className={iconStyle} aria-hidden="true" />,
    settingsIcon: <Cog6ToothIcon className={iconStyle} aria-hidden="true" />,
    creditCardIcon: <CreditCardIcon className={iconStyle} aria-hidden="true" />,
    plusIcon: <PlusIcon className={iconStyle} aria-hidden="true" />,
    trashIcon: <TrashIcon className={iconStyle} aria-hidden="true" />,
    newspaperIcon: <NewspaperIcon className={iconStyle} aria-hidden="true" />,
    clockIcon: <ClockIcon className={iconStyle} aria-hidden="true" />,
    pencilIcon: <PencilIcon className={iconStyle} aria-hidden="true" />,
    pencilSquareIcon: (
      <PencilSquareIcon className={iconStyle} aria-hidden="true" />
    ),
    eyeIcon: <EyeIcon className={iconStyle} aria-hidden="true" />,
    eyeSlashIcon: <EyeSlashIcon className={iconStyle} aria-hidden="true" />,
    tagIcon: <TagIcon className={iconStyle} aria-hidden="true" />,
    banknotesIcon: <BanknotesIcon className={iconStyle} aria-hidden="true" />,
    calendarDaysIcon: (
      <CalendarDaysIcon className={iconStyle} aria-hidden="true" />
    ),
    noSymbolIcon: <NoSymbolIcon className={iconStyle} aria-hidden="true" />,
    presentationChartBar: (
      <PresentationChartBarIcon className={iconStyle} aria-hidden="true" />
    ),
    xCircleIcon: <XCircleIcon className={iconStyle} aria-hidden="true" />,
    shieldExclamationIcon: (
      <ShieldExclamationIcon className={iconStyle} aria-hidden="true" />
    ),
    shieldCheckIcon: (
      <ShieldCheckIcon className={iconStyle} aria-hidden="true" />
    ),
    cogIcon: <CogIcon className={iconStyle} aria-hidden="true" />,
    documentTextIcon: (
      <DocumentTextIcon className={iconStyle} aria-hidden="true" />
    ),
    identificationIcon: (
      <IdentificationIcon className={iconStyle} aria-hidden="true" />
    ),
    squares2X2Icon: <Squares2X2Icon className={iconStyle} aria-hidden="true" />,
    megaphoneIcon: <MegaphoneIcon className={iconStyle} aria-hidden="true" />,
    windowIcon: <WindowIcon className={iconStyle} aria-hidden="true" />,
    phoneIcon: <PhoneIcon className={iconStyle} aria-hidden="true" />,
    funnelIcon: <FunnelIcon className={iconStyle} aria-hidden="true" />,
    lockIcon: <LockClosedIcon className={iconStyle} aria-hidden="true" />,
    unlockIcon: <LockOpenIcon className={iconStyle} aria-hidden="true" />,
  };
  return Icons[name];
};

export default IconSvg;
export type { HeroIconsName };
